<template>
    <section class="section">
      <div class="container">
        <div class="section__block">
          <h2 class="text-center mb-5 headline--underlined">Aktuelles</h2>
        </div>
        <div class="section__block">
          <div id="news-card">
            <template v-if="news && news.length > 6">
              <div
                  ref="splide"
                  class="splide"
                  aria-label="Splide Basic HTML Example"
              >
                <div class="splide__track">
                  <ul class="splide__list" ref="splideList">
                    <li
                        class="splide__slide"
                        v-for="newsItem in news"
                        :key="newsItem.id"
                    >
                      <article class="card">
                        <figure v-if="imageSrc(newsItem)">
                          <img class="card-img-top" :src="imageSrc(newsItem)" alt="Card image"/>
                        </figure>
                        <div class="card-body">
                          <h3 class="card-title">{{ newsItem.title }}</h3>
                          <p class="card-text">{{ newsItem.text }}</p>
                          <router-link :to="{ name: 'focusNews', params: {id: newsItem.id}}"
                                       class="card__link link link--internal">weiterlesen
                          </router-link>
                        </div>
                      </article>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
            <div class="row justify-content-center" v-else>
              <div class="col-12 col-md-6 col-lg-4" v-for="newsItem in news" :key="newsItem.id">
                <article
                    class="card"
                >
                  <figure>
                    <img v-if="imageSrc(newsItem)" class="card-img-top" :src="imageSrc(newsItem)" alt="Card image"/>
                  </figure>

                  <span class="badge rounded-pill" :style="{ backgroundColor: 'var(' + getClubById(newsItem.clubId)?.backgroundColor + ')' }">{{getClubById(newsItem.clubId)?.name}}</span>
                  <div class="card-body">
                    <h3 class="card-title">{{ newsItem.title }}</h3>
                    <p class="card-text">{{ newsItem.text }}</p>
                    <router-link :to="{ name: 'focusNews', params: {id: newsItem.id}}"
                                 class="card__link link link--internal">weiterlesen
                    </router-link>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
        <div class="section__block">
          <div class="d-flex flex-column flex-md-row gap-2 justify-content-center">
            <template v-if="news.length > 0">
              <router-link v-if="origin==='general' && $route.name !== 'allMainNews'" :to="{ name: 'allMainNews', params: {type: origin}}"
                           class="btn btn-primary"
              >Alle Nachrichten
              </router-link>
              <router-link v-else :to="{ name: 'allClubNews', params: {type: origin}}"
                           class="btn btn-primary"
              >Alle Nachrichten
              </router-link>
            </template>
            <router-link v-if="userCheckResult" :to="{ name: 'editMainNews', params: {type: origin}}" class="btn btn-warning">
              Neue Nachricht anlegen
            </router-link>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
import {onMounted, ref, computed, onUpdated} from "vue";
import axios from "axios";
import Splide from "@splidejs/splide";
import {Grid} from "@splidejs/splide-extension-grid";

export default {
  name: "News",
  computed: {
    userCheckResult() {
      return localStorage.getItem('userCheckResult');
    }
  },
  props: {
    news: Array,
    origin: String
  },
  setup() {
    // Reference to the Splide container
    const splide = ref(null);
    const splideList = ref(null);

    const initSlider = () => {
      const minGridItems = 6;

      // Check if the slider has at least 'minItems' items
      if (
          splideList.value &&
          splideList.value.children.length > minGridItems
      ) {
        // Initialize Splide on the container
        new Splide(splide.value, {
          type: "slider",
          perPage: 3,
          gap: "1.5rem",
          padding: {left: 20, right: 20, top: 20, bottom: 20},
          grid: {
            rows: 2,
            cols: 1,
            gap: {
              row: "1.5rem",
            },
          },
        }).mount({Grid});
      }
      
    }

    const clubs = ref([]);

    const fetchClubs = async() => {
      try {
        const response = await axios.get('http://localhost:8082/gemeinde/clubs');
        clubs.value = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const getClubById = (clubId) => {
      return clubs.value.find(club => club.id === clubId);
    };

    onMounted(() => {
          initSlider();
          fetchClubs();
        },
    );

    onUpdated(() => {
      initSlider();
    })
    // Computed Property für das Bild
    const imageSrc = computed(() => (newsItem) => {
      return newsItem.imageName
          ? 'http://localhost:8082/' + newsItem.imageName.split('/').pop()
          : new URL('@/assets/images/news-placeholder.png', import.meta.url).href;
    });

    return {
      splide,
      splideList,
      imageSrc,
      getClubById,
    };
  }
};
</script>

<style>
.badge {
  color: #000 !important;
  position: absolute;
  top: 10px;
  right: 10px;
  width: fit-content;
  max-width: 100%;
  white-space: normal !important;
  margin-left: 10px;
}
</style>
